<div class="modifier-class js-tab-group">
    <nav class="tab-nav">
        <a id="text-tab-title" class="tab-title js-tab" (click)="activateTabByName('text')">Text</a>
        <a id="point-tab-title" class="tab-title js-tab" (click)="activateTabByName('point')">Point</a>
        <a id="line-tab-title" class="tab-title js-tab" (click)="activateTabByName('line')">Line</a>
        <a id="polygon-tab-title" class="tab-title js-tab" (click)="activateTabByName('polygon')">Polygon</a>
    </nav>
    <section class="tab-contents">
        <article class="tab-section js-tab-section">
            <mc-draw-text #textTab></mc-draw-text>
        </article>
        <article class="tab-section js-tab-section is-active">
            <mc-draw-point #pointTab (drawComplete)="onDrawComplete($event)"></mc-draw-point>
        </article>
        <article class="tab-section js-tab-section">
            <mc-draw-line #lineTab (drawComplete)="onDrawComplete($event)"></mc-draw-line>
        </article>
        <article class="tab-section js-tab-section">
            <mc-draw-polygon #polygonTab (drawComplete)="onDrawComplete($event)"></mc-draw-polygon>
        </article>
    </section>
</div>